import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as n } from "./index.es2361.js";
const p = (d) => {
  const { outline: l, fill: o, size: i } = n(d);
  return /* @__PURE__ */ t(
    "svg",
    {
      width: i,
      height: i,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": d["data-testid"],
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.4834 0.375V4.517C11.4834 5.068 11.9314 5.517 12.4834 5.517H16.6254",
            fill: o
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.4834 0C11.6905 0 11.8584 0.167893 11.8584 0.375V4.517C11.8584 4.86114 12.1388 5.142 12.4834 5.142H16.6254C16.8325 5.142 17.0004 5.30989 17.0004 5.517C17.0004 5.72411 16.8325 5.892 16.6254 5.892H12.4834C11.724 5.892 11.1084 5.27486 11.1084 4.517V0.375C11.1084 0.167893 11.2763 0 11.4834 0Z",
            fill: l
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 1.375C1 0.614649 1.61614 0 2.375 0H11.8763L17 5.12367V16.625C17 17.3851 16.3851 18 15.625 18H2.375C1.61614 18 1 17.3854 1 16.625V1.375ZM2.375 0.75C2.02986 0.75 1.75 1.02935 1.75 1.375V16.625C1.75 16.9706 2.02986 17.25 2.375 17.25H15.625C15.9709 17.25 16.25 16.9709 16.25 16.625V5.43433L11.5657 0.75H2.375Z",
            fill: l
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.625 11.5836V5.7246H9.375V11.5836H8.625Z",
            fill: l
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 11.3125L6.97417 9.28663L6.44384 9.81696L9 12.3731L11.5562 9.81696L11.0258 9.28663L9 11.3125Z",
            fill: l
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.0707 13.4492H11.9297V14.1992H6.0707V13.4492Z",
            fill: l
          }
        )
      ]
    }
  );
};
p.__tags = [];
export {
  p as ExportIcon
};
//# sourceMappingURL=index.es271.js.map
